(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('WidgetPluviometrosSettingsCtrl', WidgetPluviometrosSettings);

  WidgetPluviometrosSettings.$inject = [
    'widget',
    '$uibModalInstance'
  ];

  function WidgetPluviometrosSettings(widget, $uibModalInstance) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.result = jQuery.extend(true, {}, widget); // https://github.com/DataTorrent/malhar-angular-dashboard/blob/master/src/app/customWidgetSettings.js#L123
    vm.datepickerInicialOpen = false;
    vm.datepickerFinalOpen = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.toggleInitialDatepicker = ToggleInitialDatepicker;
    vm.toggleEndDatepicker = ToggleEndDatepicker;
    vm.set15DaysAgo = Set15DaysAgo;
    vm.set30DaysAgo = Set30DaysAgo;
    vm.set60DaysAgo = Set60DaysAgo;
    vm.ok = OK;
    vm.cancel = Cancel;
    vm.notInterval = NotInterval;

    //////////////////////////////////////////
    // Function declarations

    function ToggleInitialDatepicker() {
      vm.datepickerInicialOpen = !vm.datepickerInicialOpen;
    }

    function ToggleEndDatepicker() {
      vm.datepickerFinalOpen = !vm.datepickerFinalOpen;
    }

    function SetInitialDateToToday() {
      vm.result.dataModelOptions.dataFinal = new Date();
    }

    function SetEndDateXDaysAgo(days = 15) {
      vm.result.dataModelOptions.intervalShortcut = days;
      vm.result.dataModelOptions.dataInicial = moment().subtract(days, 'days').toDate();
    }

    function Set15DaysAgo() {
      SetEndDateXDaysAgo(15);
      SetInitialDateToToday();
    }

    function Set30DaysAgo() {
      SetEndDateXDaysAgo(30);
      SetInitialDateToToday();
    }

    function Set60DaysAgo() {
      SetEndDateXDaysAgo(60);
      SetInitialDateToToday();
    }

    function OK() {
      $uibModalInstance.close(vm.result);
    }

    function Cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function NotInterval() {
      delete vm.result.dataModelOptions.intervalShortcut;
    }

    //////////////////////////////////////////
    // Controller logic

    if (vm.result.dataModelOptions.intervalShortcut) {
      const today = moment();
      vm.result.dataModelOptions.dataInicial = today.clone().subtract(vm.result.dataModelOptions.intervalShortcut, 'days').toDate();
      vm.result.dataModelOptions.dataFinal = today.toDate();
    }
  }

}());
